<lib-modal
    [title]="'my-tasks.location-check-modal'"
    [componentID]="'location-check-modal'"
>
    <p>{{ 'my-tasks.location-check-modal-text' | translate }}</p>

    <p>
        <i class="fa fa-map-marker map-icon"></i>
        <strong>{{ 'my-tasks.location-address' | translate }}: </strong>
        <span *ngIf="address; else noAddress">{{ address }}</span>
    </p>

    <ng-template #noAddress>
        <span>{{ 'my-tasks.location-address-not-found' | translate }}</span>
    </ng-template>

    <div class="text-center mt-3 mb-3" *ngIf="!showMap && hasLocation">
        <button class="btn btn-outline-primary" type="button" (click)="loadMap()">
            <i class="fa fa-map me-1"></i>
            {{ 'my-tasks.load-map' | translate }}
        </button>
    </div>

    <div *ngIf="showMap" class="mt-3">
        <div class="map-container" #mapContainer>
            <google-map
                [center]="center"
                [zoom]="zoom"
                [options]="mapOptions"
                [height]="400"
                [width]="320"
            >
                <map-marker
                    *ngFor="let marker of markers"
                    [position]="marker"
                ></map-marker>
            </google-map>
        </div>
    </div>

    <div class="btn-toolbar justify-content-between text-center mt-2">
        <div class="btn-group m-auto">
            <button 
            appPreventDoubleClick
            class="btn btn-success"
            type="button"
            [throttleTime]="3000"
            [disableTime]="3000"
            (throttledClick)="acceptLocation()"
            >
                <i class="fa fa-check me-1"></i>
                {{ 'my-tasks.accept-location' | translate }}
            </button>

            <button class="btn btn-danger" type="button" (click)="closeModal()">
                <i class="fa fa-undo me-1"></i>
                {{ 'my-tasks.decline-location' | translate }}
            </button>
        </div>
    </div>
</lib-modal>
